import React from "react";
import Icon from "sulu-admin-bundle/components/Icon/Icon.js";
import overrides from "./../../../css/customization.scss"
import style from './../../../css/components/buttons.scss'

const QuarterButton = ({
  quarterDetails,
  quarter,
  quarterSelected,
  setQuarterSelected,
  matchData,
  periodNumber
}) => {
  const isSelected = quarter === quarterSelected;
  const { matchHasShootout } = matchData;
  if(quarter === 'SO' && !matchHasShootout) {
    return null;
  }
  
  let period = '';
  if (quarter === 'SO') {
    period = 'SO';
  } else {
    period = matchData?.formatObject?.periodAbbreviation + periodNumber;
  }

  return (
    <button
      onClick={() => {
        if(!isSelected) {
          return;
        }
        setQuarterSelected(quarter);
      }}
      style={{
        backgroundColor: isSelected ? "white" : "lightgray",
        border: isSelected ? "1px solid lightgray" : "none",
        cursor: !isSelected ? 'not-allowed' : 'pointer'
      }}
      className={`${overrides.fontRoboto} ${style.quarterBtn}`}
    >
      <span>{period}</span>
      {quarterDetails?.quarterStarted && !quarterDetails?.quarterEnded ? <Icon name="su-caret-right-fill" /> : null}
      {quarterDetails?.quarterEnded && <Icon name="su-check" />}
      {quarterDetails?.quarterStopped && !quarterDetails?.quarterEnded ? <Icon name="su-square" /> : null}
    </button>
  );
};
export default QuarterButton;
